import { createAsyncThunk, createSlice,PayloadAction } from "@reduxjs/toolkit";
import fetchAPI from "../../../common/fetchAPI";
import { StatusStateClass } from "./interfaces/StatusStateClass";
import { RootState } from "../../../app/store";
import { sortData } from "../../../common/timeLiveFunction";
const initialState: StatusStateClass = {
    isLoading: true,
    StatusList: [],
    status: "idle",
    selectedRecord: {},
    isReload: false,
    sortOrder: 'asc',
    sortColumn: 'StatusTypeId',
    search: '',
    pageNo: 1,
    pageSize: 10
};


interface IThunkApi {
    state: {
        status: StatusStateClass
    }
}


export const getAccountStatusAsync = createAsyncThunk
    <any, void, IThunkApi>
    (
        "Status/v2/getAccountStatus",
        async (arg, thunkApi) => {
            //const response = await fetchAPI("api/Statuses","GET","",true,"0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
            const response = await fetchAPI("api/v2/Status", "GET", "", true, "0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
            const json = await response.json();
            return json;
        }
    )
export const getAccountStatusByAccountStatusIdAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        "Status/v2/getAccountStatusByAccountStatusId",
        async (arg, thunkApi) => {
            //const response = await fetchAPI("api/Statuses/" + arg,"GET","",true,"0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
            const response = await fetchAPI("api/v2/Status/" + arg, "GET", "", true, "0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
            const json = await response.json();
            return json;
        }
    )
export const addAccountStatusAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'Status/v2/addAccountStatus',
        async (arg, thunkApi) => {
            //const response = await fetchAPI('api/Statuses/', 'POST', arg, true, '0df3ab0c-4033-4013-8b1e-2f0b64f8cbab');
            const response = await fetchAPI('api/v2/Status/', 'POST', arg, true, '0df3ab0c-4033-4013-8b1e-2f0b64f8cbab');
            const json = await response.json();
            return json;
        }
    )

export const updateAccountStatusAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'Status/v2/updateAccountStatus',
        async (arg, thunkApi) => {
            //const {AccountLocationId} = arg;
            const { AccountStatusId, ...argWithoutId } = arg;
            //const response = await fetchAPI('api/Statuses/' + AccountStatusId, 'POST', argWithoutId, true, '0df3ab0c-4033-4013-8b1e-2f0b64f8cbab');
            const response = await fetchAPI('api/v2/Status/' + AccountStatusId, 'PUT', argWithoutId, true, '0df3ab0c-4033-4013-8b1e-2f0b64f8cbab');
            const json = await response.json();
            return json;
        }
    )
export const deleteAccountStatusAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        "Status/v2/deleteAccountStatus",
        async (arg, thunkApi) => {
            // const response = await fetchAPI("api/Statuses/" + arg,"Delete","",true,"0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
            const response = await fetchAPI("api/v2/Status/" + arg, "Delete", "", true, "0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
            const json = await response.json();
            return json;
        }
    )
export const DeleteSelectedAccountStatusAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        "Status/v2/DeleteSelectedAccountStatus",
        async (arg, thunkApi) => {
            //const response = await fetchAPI('api/v2/Status/DeleteSelected/','Delete',arg,true,'0df3ab0c-4033-4013-8b1e-2f0b64f8cbab');
            const response = await fetchAPI('api/v2/Status/DeleteSelected/', 'Delete', arg, true, '0df3ab0c-4033-4013-8b1e-2f0b64f8cbab');
            const json = await response.json();
            return json;

        }
    )
export const statusSlice = createSlice({
    name: "Status",
    initialState,
    reducers: {
        resetSelectedRecordObjectInState: (state) => {
            state.selectedRecord = {}
        },
        checkedState: (state, action) => {
            const currentindex = state.StatusList.findIndex((item) => item.AccountStatusId == action.payload);
            const newArray = [...state.StatusList];
            newArray[currentindex] = { ...newArray[currentindex], isSelected: 1 };
            state.StatusList = newArray;
        },
        unCheckedState: (state, action) => {
            const currentindex = state.StatusList.findIndex((item) => item.AccountStatusId == action.payload);
            const newArray = [...state.StatusList];
            newArray[currentindex] = { ...newArray[currentindex], isSelected: 0 };
            state.StatusList = newArray;
        },
        checkedAllState: (state) => {
            const newArray = state.StatusList.map((item) => ({
                ...item,
                isSelected: 1,
            }));
            state.StatusList = newArray;
            //state.isAllUnChecked = false;
        },
        unCheckedAllState: (state) => {
            const newArray = state.StatusList.map((item) => ({
                ...item,
                isSelected: 0,
            }));
            state.StatusList = newArray;
            //state.isAllUnChecked = true;
        },
        checkAllCheckboxIsUncheckedState: (state) => {
            //state.isAllUnChecked = state.LocationList.every((item) => item.isSelected === 0);
        },
        updatePagination: (state, action: PayloadAction<any>) => {
            state.pageSize = action.payload.pageSize;
            state.pageNo = action.payload.pageNo;
            state.search = action.payload.search;
        },
        updateSorting: (state, action) => {
            state.sortOrder = action.payload.sortOrder;
            state.sortColumn = action.payload.sortColumn;
            state.pageSize = action.payload.pageSize;
            state.pageNo = action.payload.pageNo;
            let tempArray = state.StatusList;
            state.StatusList = sortData(tempArray, action.payload.sortOrder, action.payload.sortColumn);
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getAccountStatusAsync.pending, (state) => {
                state.status = "loading";
                state.isLoading = true;
            })
            .addCase(getAccountStatusAsync.fulfilled, (state, { payload }) => {
                state.status = "idle";
                if (Object.keys(payload.Data).length === 0) {
                    // Handle the case where payload.Data is empty or an empty object
                    state.StatusList = [];
                } else {
                    state.StatusList = payload.Data;
                    state.StatusList.map((item: any) => {
                        item.isSelected = 0
                    });
                }

                state.isReload = false;
                state.isLoading = false;
                state.selectedRecord = {};
            })
            .addCase(getAccountStatusAsync.rejected, (state) => {
                state.status = "failed";
                state.isLoading = false;

            })
            .addCase(getAccountStatusByAccountStatusIdAsync.pending, (state) => {
                state.status = "loading";
                state.isLoading = true;
            })
            .addCase(getAccountStatusByAccountStatusIdAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.selectedRecord = payload.Data[0];
                state.isLoading = false;
            })
            .addCase(getAccountStatusByAccountStatusIdAsync.rejected, (state) => {
                state.status = "failed";
                state.isLoading = false;
            })

            ///
            .addCase(addAccountStatusAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(addAccountStatusAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = true;
                state.isLoading = false;
            })
            .addCase(addAccountStatusAsync.rejected, (state) => {
                state.status = 'failed';
            })

            .addCase(updateAccountStatusAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(updateAccountStatusAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = true;
                state.isLoading = false;
            })
            .addCase(updateAccountStatusAsync.rejected, (state) => {
                state.status = 'failed';
            })

            .addCase(deleteAccountStatusAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(deleteAccountStatusAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = true;
                state.isLoading = false;
            })
            .addCase(deleteAccountStatusAsync.rejected, (state) => {
                state.status = 'failed';
            })

            .addCase(DeleteSelectedAccountStatusAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(DeleteSelectedAccountStatusAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = true;
                state.isLoading = false;
            })
            .addCase(DeleteSelectedAccountStatusAsync.rejected, (state) => {
                state.status = 'failed';
            })



    }
})

export const { resetSelectedRecordObjectInState, checkedState, unCheckedState, checkedAllState, unCheckedAllState, checkAllCheckboxIsUncheckedState,updateSorting, updatePagination } = statusSlice.actions
export const statusState = (state: RootState) => state.status
export default statusSlice.reducer